// Loader.jsx
import React from "react";

const Loader = ({ loading, children }) => {
    return (
        <div style={{ position: "relative" }}>
            {/* Content */}
            <div
                style={
                    loading
                        ? { opacity: 0.4, pointerEvents: "none" }
                        : {}
                }
            >
                {children}
            </div>

            {/* Loader Overlay */}
            {loading && (
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(255, 255, 255, 0.6)",
                        borderRadius: "0.5rem", // 8px like Tailwind rounded-lg
                    }}
                >
                    <div
                        style={{
                            width: "2rem", // w-8
                            height: "2rem", // h-8
                            borderWidth: "4px",
                            borderStyle: "solid",
                            borderColor: "#d1d5db", // border-gray-300
                            borderTopColor: "black", // border-t-black
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                        }}
                    ></div>
                </div>
            )}

            {/* Spinner Keyframes */}
            <style>
                {`
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
                `}
            </style>
        </div>
    );
};

export default Loader;
